import GoldenSpinerHeader from 'Components/GoldenSpinerHeader';
import { PlusButton } from 'Components/Header';
import SpinerHeader from 'Components/SpinerHeader';
import AppContext from 'Contexts/AppContext';
import UserContext from 'Contexts/User';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap';
import useSound from 'use-sound';
// @ts-ignore
import buttonClick from "../../assets/sounds/buttonClick.mp3";
import { Link, useNavigate } from 'react-router-dom';

function VoteEndPopup() {
    const { user, setUser, userInfo } = useContext(UserContext);
    const [voteNumber, setVoteNumber] = useState(0);
    const {   
    afterVotePopup,
    setAfterVotePopup,
    showMenubar,    
    freeSpinData,    
    spinAccessLimit, 
    headerExtraVote,
    setvoteNumberEnd,                      
  } = useContext(AppContext);
    const prevCountRef = useRef(voteNumber);
    const [handleSoundClick] = useSound(buttonClick);
    const navigate = useNavigate();

  useEffect(() => {
    setVoteNumber(
      Number(userInfo?.voteValue || 0) +
      Number(userInfo?.rewardStatistics?.extraVote || 0));        
    setvoteNumberEnd(Number(userInfo?.voteValue));
    // @ts-ignore
    prevCountRef.current = voteNumber;    
  }, [
    userInfo?.voteValue,
    userInfo?.rewardStatistics?.extraVote,
    headerExtraVote?.vote,
  ]);

    const handleClose = () => {
    setAfterVotePopup(false);
  };


  return (
    <div>
      <Modal
              dialogClassName="modal-35w"
              show={afterVotePopup}
              size="lg"
              onHide={handleClose}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              style={{ opacity: 1, zIndex: 9999 }}
              className="borderColor"              
              backdrop="static"
              contentClassName={window.screen.width <= 750 ? "w-100" : "w-50"}
            >
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn-close "
                  aria-label="Close"
                  onClick={() => {
                    handleClose();
                  }}
                ></button>
              </div>              
              <Modal.Body>
                <div className="d-flex justify-content-center pb-4">
                  <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                    <p className="text-uppercase text-center">
                      {" "}
                      Out of votes? &nbsp;
                    </p>
                    {(voteNumber === 0 && freeSpinData?.freeSpinAvailable && freeSpinData?.spinnerEnabled == true) ?
                      <div
                        style={{
                          width: "35px",
                          height: "28px",                          
                        }}
                        onClick={() => {                          
                          handleClose()
                          if (!showMenubar) {
                            handleSoundClick();
                            navigate("/wheel");
                          }
                        }}
                      >                        
                        {userInfo?.voteValue >= spinAccessLimit?<GoldenSpinerHeader />:<SpinerHeader />}
                      </div>
                    : <PlusButton
                      className="d-flex justify-content-center"
                      style={{ padding: "1px", fontSize: "17px" }}
                      onClick={() => {
                        handleClose()
                        if (!showMenubar) {
                          handleSoundClick();                                         
                            navigate("/votingbooster");                          
                        }
                      }}
                    >
                      <span className={`text-center HeaderText`}>+</span>
                    </PlusButton>}
                  </div>
                </div>
                {/* <hr /> */}

                <div className="text-center d-flex" style={{justifyContent:"center"}}>                   
                  <pre>
                  {voteNumber === 0  && freeSpinData?.freeSpinAvailable > 0 && freeSpinData?.spinnerEnabled == true? <Link
                  
                      style={{ color: "#6352e8", textDecoration: "underline" }}
                    className="text-uppercase"
                    to="/wheel"
                    
                  >                    
                      Free spin available                    
                  </Link>:
                  <Link
                    style={{ color: "#6352e8", textDecoration: "underline" }}
                    className="text-uppercase"
                    to="/votingbooster"
                    onClick={() => {
                      handleSoundClick();
                      handleClose()
                      navigate("/votingbooster");
                    }}
                  >                    
                    Buy Extra votes                   
                  </Link>}
                  </pre>
                </div>
              </Modal.Body>
            </Modal>
    </div>
  )
}

export default VoteEndPopup
